module.exports = __webpack_public_path__ + "static/img/a4en.719dfc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet/a4en.png
// module id = X0mq
// module chunks = 0